<template>
  <div class="registerform__step step__two">
    <div class="step__content">
      <div class="progress-bar">
        <Progressbar
        :active="2"
        @updateStep="$emit('updateStep', $event)"/>
      </div>
      <div class="step__form">
        <div class="form__headline">
          <h4 class="-color-alpha">Heben Sie Ihre Vermietung auf die nächste Stufe</h4>
          <p>Aus rechtlichen Gründen ist es notwenig, dass Sie eine gewerbliche Vermietung betreiben um unsere Software nutzen zu können. Bitte geben Sie im folgenden an, ob Sie bereits ein Gewerbe für Ihre Vermietung haben oder sich vorstellen können Ihre Vermietung gewerblich zu betreiben.</p>
        </div>
        <div class="form__form">
          <div class="field__wrap -decreased-width">
            <div class="col">
              <RadioButton
                  label="Gewerbliche Vermietung möglich? *"
                  identifier="commercial"
                  :items="[{ value: '1', identifier: 'yes', text: 'Ja' },{ value: '0', identifier: 'no', text: 'Nein' }]"
                  v-model="isCommercial"
                  :error="error && isCommercialIsMissing" />
            </div>
          </div>
        </div>
        <div class="form__action">
          <div class="-btn-alpha" @click="nextStep()"><span>Weiter zur Adresseingabe</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Progressbar from '../Progressbar.vue'
import RadioButton from '../form/CmInputTypeRadio.vue'
export default {
  name: 'StepTwo',
  data () {
    return {
      error: false
    }
  },
  props: {
    registerform: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Progressbar,
    RadioButton
  },
  computed: {
    isCommercial: {
      get: function () {
        return this.registerform.isCommercial
      },
      set: function (val) {
        this.$emit('updateForm', { isCommercial: val })
      }
    },
    isCommercialIsMissing: function () {
      return this.isCommercial === ''
    }
  },
  methods: {
    nextStep: function () {
      if (!this.isCommercialIsMissing) {
        this.error = false
        this.$emit('updateStep', 'StepThree')
      } else {
        this.error = true
      }
    }
  }
}
</script>
